export default "__VITE_ASSET__963177de__"